import { render, staticRenderFns } from "./TitleAndDataNames.vue?vue&type=template&id=22697172&"
import script from "./TitleAndDataNames.vue?vue&type=script&lang=js&"
export * from "./TitleAndDataNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports